import { useFloatingIconDrag } from 'hooks/useFloatingIconDrag';

/**
 * The MINIMIZED state of the sizer selection popup —
 * `header/tmpl/sizer_floating_icon.tmpl` (4 lines), swapped in by `minimize()`
 * (`header/view/sizer_popup.js:735-751`) and made draggable on the next line:
 *
 *   self.$el[0].innerHTML = self.floatingIconTmpl();
 *   self.floating_icon_element_jq = $("#floating-icon");
 *   self.floating_icon_element_jq.draggable();     // :745
 *
 * Clicking it re-opens the popup (`events`: `"click #floating-icon":
 * "open_popup"`, :40) — so the drag has to leave a plain click alone, which is
 * what `useFloatingIconDrag`'s slop threshold does. Position is not persisted,
 * matching the bare `.draggable()`.
 */

export interface SizerFloatingIconProps {
  onOpen: () => void;
}

export const SizerFloatingIcon = ({ onOpen }: SizerFloatingIconProps) => {
  const { ref, dragProps } = useFloatingIconDrag<HTMLDivElement>({ onClick: onOpen });

  return (
    <div
      ref={ref}
      id="floating-icon"
      /* `ui-draggable ui-draggable-handle` — the classes jQuery UI's
         `.draggable()` adds, kept for DOM parity. */
      className="floating-icon ui-draggable ui-draggable-handle"
      {...dragProps}
    >
      <i className="icon-sizer-1" />
      <span className="icon-title">AHU Sizer</span>
    </div>
  );
};

export default SizerFloatingIcon;
